export default "__VITE_ASSET__pK1W5HoT__"